"use client";

import type { HTMLAttributes, Ref } from "react";

import cn from "../../utils/cn.util";
import { useIconSwapContext } from "./context";
import { itemStyles } from "./styles";

export type IconSwapItemProps = HTMLAttributes<HTMLSpanElement> & {
  /** Shown while it matches the root's `value`. */
  value: string;
  ref?: Ref<HTMLSpanElement>;
};

export const Item = ({ value, className, children, ...props }: IconSwapItemProps) => {
  const context = useIconSwapContext();

  return (
    <span className={cn(itemStyles({ active: context.value === value }), className)} {...props}>
      {children}
    </span>
  );
};

Item.displayName = "IconSwapItem";
